import Breadcrumbs, { type Crumb } from '../../components/Breadcrumbs';

interface PlaceholderPageProps {
  title: string;
  description?: string;
  breadcrumbs?: Crumb[];
}

/** Generic stub for sections not built yet. */
export default function PlaceholderPage({ title, description, breadcrumbs }: PlaceholderPageProps) {
  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-2">
        {breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
        <h1 className="text-2xl font-semibold leading-9 tracking-[-0.75px] text-ink">{title}</h1>
        <p className="max-w-[672px] text-sm leading-6 text-ink-secondary">
          {description ?? 'This section is coming soon.'}
        </p>
      </div>
      <div className="flex h-64 items-center justify-center rounded-xl border border-dashed border-line/50 bg-white text-sm text-ink-secondary">
        {title} — coming soon
      </div>
    </div>
  );
}
